// src/pages/Sport.jsx
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Layout from "./Layout";
import SportSection from "../sections/SportSection";
import { resolveHayllis2SportRedirect } from "../utils/hayllis2SportRedirect.js";

const Sport = () => {
  const { idevent, idsport } = useParams();
  // FTR-0039: los deportes de los eventos configurados (hoy solo 1001) se ven en Hayllis 2.0, en ese mismo
  // evento y deporte, salvo las excepciones de ese evento (1001: vóley 16 y 17 siguen aquí). Se decide antes de
  // montar SportSection para no lanzar sus consultas; `replace` evita que "Atrás" vuelva a esta URL y redirija
  // otra vez. Cualquier otro evento o deporte sigue aquí exactamente igual.
  const hayllis2Url = resolveHayllis2SportRedirect({ idevent, idsport });

  useEffect(() => {
    if (hayllis2Url) window.location.replace(hayllis2Url);
  }, [hayllis2Url]);

  if (hayllis2Url) {
    return (
      <Layout>
        <p className="py-16 text-center text-sm text-gray-600">
          Redirigiendo a Hayllis 2.0…{" "}
          <a href={hayllis2Url} className="font-semibold underline">
            Abrir el deporte
          </a>
        </p>
      </Layout>
    );
  }

  return (
    <Layout>
      <SportSection />
    </Layout>
  );
};

export default Sport;
